// extracted by mini-css-extract-plugin
export default {"remove_confirm_menu":"removeConfirm_remove_confirm_menu__XW46k","confirm":"removeConfirm_confirm__6P6Ov","no":"removeConfirm_no__sMWjY","yes":"removeConfirm_yes__ccjxQ"};